import * as React from 'react';
import { AppAudioBarProps } from './AppAudioBar.props';
import { Stack } from 'office-ui-fabric-react';
import { getAudioBarStyles, audioBarStackStyles } from './AppAudioBar.styles';
import { FormatTimeDescription, FormatTime } from '../../../utils';

const SEEK_STEP_SECONDS = 5;

export const AppAudioBar: React.FunctionComponent<AppAudioBarProps> = (props: AppAudioBarProps) => {
  const audioBarRef = React.createRef<HTMLDivElement>();
  const { currentTime, duration, onTimeChange } = props;
  const currentPercentage = Math.min((currentTime / duration) * 100, 100);

  const styles = getAudioBarStyles(currentPercentage);

  const _onBarMouseDown = (event: React.MouseEvent): void => {
    if(!audioBarRef.current) {
      return;
    }

    let audioBarRect = audioBarRef.current.getBoundingClientRect();
    let currentTimeInPercentage = (event.clientX - audioBarRect.left) / audioBarRect.width;

    if(onTimeChange) {
     onTimeChange(currentTimeInPercentage * duration);
    }
  }

  const _onBarKeyDown = (event: React.KeyboardEvent): void => {
    if (!onTimeChange) {
      return;
    }

    let newTime: number | undefined;
    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowUp':
        newTime = Math.min(currentTime + SEEK_STEP_SECONDS, duration);
        break;
      case 'ArrowLeft':
      case 'ArrowDown':
        newTime = Math.max(currentTime - SEEK_STEP_SECONDS, 0);
        break;
      case 'Home':
        newTime = 0;
        break;
      case 'End':
        newTime = duration;
        break;
      default:
        return;
    }

    event.preventDefault();
    onTimeChange(newTime);
  }

  return (
    <Stack horizontalAlign="center" styles={audioBarStackStyles}>
      <div
        id='audioBar'
        className={styles.bar}
        ref={audioBarRef}
        role="slider"
        tabIndex={0}
        aria-label={TranscriptionStrings.PlaybackSeekBarText}
        aria-valuemin={0}
        aria-valuemax={Math.round(duration)}
        aria-valuenow={Math.min(Math.max(Math.round(currentTime), 0), Math.round(duration))}
        aria-valuetext={FormatTimeDescription(currentTime, true /* show seconds */)}
        onMouseDown={_onBarMouseDown}
        onKeyDown={_onBarKeyDown}
      >
        <div className={styles.knob} style={{ left: `${currentPercentage - 2}%` }}>
        </div>
      </div>
      <div className={styles.timeContainer}>
        <div><span aria-label={FormatTimeDescription(currentTime, true /* show seconds */)}>{FormatTime(currentTime)}</span></div>
        <div className={styles.duration} aria-label={FormatTimeDescription(duration, true /* show seconds */)}>{FormatTime(duration)}</div>
      </div>
    </Stack>
  );
}